import { render, staticRenderFns } from "./ProcessingComments.vue?vue&type=template&id=1334b601&scoped=true&"
import script from "./ProcessingComments.vue?vue&type=script&lang=js&"
export * from "./ProcessingComments.vue?vue&type=script&lang=js&"
import style0 from "./ProcessingComments.vue?vue&type=style&index=0&id=1334b601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334b601",
  null
  
)

export default component.exports